import * as types from './constants';

// Get Shopify Collection Products
export const getShopifyCollectionProductsRequest = data => (
  { type: types.GET_SHOPIFY_COLLECTION_PRODUCTS_REQUEST, payload: data }
);

export const getShopifyCollectionProductsDone = data => (
  { type: types.GET_SHOPIFY_COLLECTION_PRODUCTS_DONE, payload: data }
);

export const getShopifyCollectionProductsFailed = errors => (
  { type: types.GET_SHOPIFY_COLLECTION_PRODUCTS_FAILED, payload: errors }
);

export const getShopifyCollectionProductsReset = () => (
  { type: types.GET_SHOPIFY_COLLECTION_PRODUCTS_RESET }
);

export const shopifyCollectionProductsProgress = data => (
  { type: types.SHOPIFY_COLLECTION_PRODUCTS_PROGRESS, payload: data }
);
